/* eslint-disable no-unreachable */
import Base from "../utils/base";
import { RSSign } from "../utils/sign";
import SyModel from "../models/sy";
import Storage from "../utils/storage.js";

const generalMethod = {
  /*
   *@description: 获取图形验证码
   *@author: 薛微微
   *@date: 2023-06-21 17:07:33
   */
  captcha: (pId, appId, type) => {
    return new Promise((resolve) => {
      let data = {
        ts: new Date().getTime(),
        cch_id: pId,
        app_id: appId,
        type: type,
        nonce: Base.nonce(12),
        version: Base.getVersion(),
        sdk_ver: Base.sdkVer(),
        sys_language: Storage.localStorageGet("lang"),
      };
      data.sign = RSSign(data, data.app_id);
      let api = JSON.parse(Storage.localStorageGet("api"));
      SyModel.getImage(api.service.image_captcha, data).then((res) => {
        resolve(res);
      });
    });
  },
  /*
   *@description: 获取token
   *@author: 薛微微
   *@date: 2023-06-21 17:07:53
   */
  freezetoken: (pId, appId, mdId) => {
    return new Promise((resolve) => {
      let data = {
        ts: new Date().getTime(),
        cch_id: pId,
        app_id: appId,
        md_id: mdId,
        nonce: Base.nonce(12),
        random: Base.nonce(12),
        version: Base.getVersion(),
        sdk_ver: Base.sdkVer(),
      };
      data.sign = RSSign(data, data.app_id);
      let api = JSON.parse(Storage.localStorageGet("api"));
      SyModel.getToken(api.service.token, data).then((res) => {
        resolve(res);
      });
    });
  },
};

export default generalMethod;
